export const stylesGenericInputLabelCP = {
  wrapper: {
    fontSize: "12px",
    color: "#474747",
    fontFamily: "AMX-Bold",
  },
  image: {
    verticalAlign: "middle",
    margin: "auto 8px",
    width: "18px",
  },
  label: { margin: "auto" },
};

export const stylesGenericInputLabelContainerTerlcel = {
  wrapper: {
    fontSize: "12px",
    color: "#222222",
    fontFamily: "AMX-Bold",
    position: "absolute",
    top: "-6px",
    left: "16px",
    padding: "0px 2px",
    backgroundColor: "#fff",
  },
  image: {
    verticalAlign: "middle",
    margin: "auto 0px auto 5px",
    position: "relative",
    bottom: "2px",
    width: "24px",
  },
  label: { margin: "auto" },
};
